/**
 * @module baggage.service
 */
import { DialVerseApi } from '../app/api'
import AppConfig from '../config'

const BaggageService = DialVerseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Basic CRUD operations
    getBaggageList: builder.mutation({
      query: () => ({
        url: AppConfig.getUrl('/bagages'),
        method: 'GET',
      }),
    }),
    createBaggage: builder.mutation({
      query: (baggageData) => ({
        url: AppConfig.getUrl('/bagages'),
        method: 'POST',
        body: baggageData,
      }),
    }),
    getBaggage: builder.mutation({
      query: (baggageId) => ({
        url: AppConfig.getUrl(`/bagages/${baggageId}`),
        method: 'GET',
      }),
    }),
    updateBaggage: builder.mutation({
      query: ({ baggageId, ...baggageData }) => ({
        url: AppConfig.getUrl(`/bagages/${baggageId}`),
        method: 'PUT',
        body: baggageData,
      }),
    }),
    deleteBaggage: builder.mutation({
      query: (baggageId) => ({
        url: AppConfig.getUrl(`/bagages/${baggageId}`),
        method: 'DELETE',
      }),
    }),

    // Baggage-specific operations
    updateBaggageStatus: builder.mutation({
      query: ({ baggageId, status }) => ({
        url: AppConfig.getUrl(`/bagages/${baggageId}/status`),
        method: 'PATCH',
        body: { status },
      }),
    }),
    assignBaggageToFlight: builder.mutation({
      query: ({ baggageId, flightId }) => ({
        url: AppConfig.getUrl(`/bagages/${baggageId}/assign-flight`),
        method: 'POST',
        body: { flightId },
      }),
    }),
    assignBaggageToPassenger: builder.mutation({
      query: ({ baggageId, passengerId }) => ({
        url: AppConfig.getUrl(`/bagages/${baggageId}/assign-passenger`),
        method: 'POST',
        body: { passengerId },
      }),
    }),

    // Relationship routes
    getBaggageByPassenger: builder.mutation({
      query: ({ passengerId, ...params }) => ({
        url: AppConfig.getUrl(`/bagages/passenger/${passengerId}`),
        method: 'GET',
        params,
      }),
    }),
    getBaggageByFlight: builder.mutation({
      query: ({ flightId, ...params }) => ({
        url: AppConfig.getUrl(`/bagages/flight/${flightId}`),
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetBaggageListMutation,
  useCreateBaggageMutation,
  useGetBaggageMutation,
  useUpdateBaggageMutation,
  useDeleteBaggageMutation,
  useUpdateBaggageStatusMutation,
  useAssignBaggageToFlightMutation,
  useAssignBaggageToPassengerMutation,
  useGetBaggageByPassengerMutation,
  useGetBaggageByFlightMutation,
} = BaggageService
